// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__m37ce","header":"Messages_header__1BlKN"};